import CrudModule from "@/components/CrudModule";
import { rupees } from "@/lib/api";
import { Home } from "lucide-react";

export default function Assets() {
    return (
        <CrudModule
            testid="assets-page"
            eyebrow="Asset Register"
            title="Property, vehicles, lockers."
            subtitle="Ownership clarity for what you own — and where the papers live."
            endpoint="/assets"
            emptyIcon={Home}
            emptyTitle="No assets yet"
            emptyBody="Add the flat, the car, the bank locker. Mention ownership and where the originals live."
            fields={[
                { key: "asset_type", label: "Asset type", type: "select", required: true, defaultValue: "property",
                  options: [
                    { value: "property", label: "Property" },
                    { value: "vehicle", label: "Vehicle" },
                    { value: "locker", label: "Bank locker" },
                    { value: "jewelry", label: "Jewelry" },
                    { value: "other", label: "Other" },
                  ] },
                { key: "name", label: "Name / Description", required: true, placeholder: "Mumbai 3BHK / Honda City…" },
                { key: "value", label: "Approx. value (₹)", type: "number" },
                { key: "ownership", label: "Ownership", type: "select", defaultValue: "self",
                  options: [
                    { value: "self", label: "Self" },
                    { value: "joint", label: "Joint" },
                    { value: "spouse", label: "Spouse" },
                    { value: "huf", label: "HUF" },
                    { value: "other", label: "Other" },
                  ] },
                { key: "location", label: "Location / Address", placeholder: "Andheri West, Mumbai" },
                { key: "notes", label: "Notes", type: "textarea" },
            ]}
            columns={[
                { key: "asset_type", label: "Type",
                  render: (r) => <span className="capitalize">{r.asset_type}</span> },
                { key: "name", label: "Name" },
                { key: "value", label: "Value", render: (r) => <span className="font-mono">{rupees(r.value)}</span> },
                { key: "ownership", label: "Ownership", render: (r) => <span className="capitalize">{r.ownership || "—"}</span> },
                { key: "location", label: "Location" },
            ]}
        />
    );
}
